import i18n from '../../i18n/index'
import importationsService from '../../services/importations/ImportationsService'

export default {
    components: {
    },
    data: () => ({
        headers: [{
            text: i18n.t('headers.plu'),
            sortable: true,
            value: 'plu'
        },
        {
            text: i18n.t('headers.internal-code'),
            sortable: false,
            value: 'internalcode'
        },
        {
            text: i18n.t('headers.description'),
            sortable: false,
            value: 'description'
        }
        ],
        providers: [],
        provider: {
            id: '',
            name: '',
            fiscalNumber: '',
            active: ''
        },
        importations: [],
        searchTerm: '',
        file: '',
        selectedProviderId: '',
        loaded: false,
        templateLink: 'http://104.248.183.112:3001/template/importations',
        loading: false
    }),
    created() {
        this.selectedProviderId = JSON.parse(localStorage.getItem('user'))
        this.selectedProviderId = this.selectedProviderId.providerId
        this.loading = true
        this.getImportations(this.selectedProviderId)
        this.loading = false
    },

    computed: {
    },

    watch: {
    },

    methods: {
        async getImportations(idProvider) {
            const aux = await importationsService.getImportations(idProvider)
            this.importations = aux.data
        },
        onChangeFileUpload() {
            if (this.$refs.file.files[0] !== undefined) {
                this.file = this.$refs.file.files[0]
                this.loaded = true
            } else {
                this.loaded = false
            }
        },
        async submitForm() {
            if (this.file !== undefined && this.file !== '') {
                this.loading = true
                let data = await importationsService.updateImportations(this.file, this.selectedProviderId)
                if (data.data == 'Missing data') {
                    this.loading = false
                    this.$notify({
                        group: 'app',
                        type: 'error',
                        text: i18n.t('copayment.bad-excel')
                    })
                } else if (data.data == 'Missing file') {
                    this.loading = false
                    this.$notify({
                        group: 'app',
                        type: 'error',
                        text: i18n.t('copayment.no-file')
                    })
                } else {
                    this.getImportations(this.selectedProviderId)
                    this.loading = false
                }
            } else {
                this.$notify({
                    group: 'app',
                    type: 'error',
                    text: 'No ha cargado el archivo de importaciones'
                })
            }
        }
    }
}
